import React from 'react'
interface ICustomButtoProps {
    label: string
    type: 'submit' | 'button'
    setShowModal?: () => void
}
export default function CustomButton({
    label,
    type,
    setShowModal,
}: ICustomButtoProps) {
    return (
        <button
            className=" w-full bg-green-1 min-h-[45px] py-3 px-4 text-center rounded-card font-bold border border-green-1 text-white-test shadow-fab hover:bg-brand-strong hover:border-brand-strong active:scale-[0.98] transition-colors"
            type={type}
            onClick={setShowModal}
        >
            {label}
        </button>
    )
}
